import React from "react"

export default function IconSadFaceReject() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 50 50" version="1.1">
      <g id="surface1">
        <g
          fill="none"
          strokeWidth="1.38"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          stroke="rgb(98.823529%,0%,0%)"
          strokeOpacity="1"
          strokeMiterlimit="10"
          transform="matrix(0.715762,-1.288615,1.288615,0.715762,-8.991745,34.714033)"
        >
          <path d="M 33.231018 16.959835 C 33.229524 25.945604 25.944265 33.229692 16.959784 33.230514 C 7.974015 33.22902 0.691214 25.946078 0.689105 16.95928 C 0.690599 7.973511 7.973541 0.69071 16.960339 0.688601 C 25.946108 0.690095 33.230196 7.975354 33.231018 16.959835 Z M 33.231018 16.959835" />
        </g>
        <g stroke="none" fillRule="nonzero" fill="rgb(98.823529%,0%,0%)" fillOpacity="1">
          <path d="M 12.074219 19.414062 C 12.074219 18.25 13.015625 17.289062 14.195312 17.289062 C 15.375 17.289062 16.316406 18.234375 16.316406 19.414062 C 16.316406 20.59375 15.375 21.535156 14.195312 21.535156 C 13.015625 21.535156 12.074219 20.59375 12.074219 19.414062 Z M 12.074219 19.414062 " />
        </g>
        <g stroke="none" fillRule="nonzero" fill="rgb(98.823529%,0%,0%)" fillOpacity="1">
          <path d="M 33.683594 19.414062 C 33.683594 18.25 34.625 17.289062 35.804688 17.289062 C 36.984375 17.289062 37.925781 18.234375 37.925781 19.414062 C 37.925781 20.59375 36.984375 21.535156 35.804688 21.535156 C 34.625 21.535156 33.683594 20.59375 33.683594 19.414062 Z M 33.683594 19.414062 " />
        </g>
        <g
          fill="none"
          strokeWidth="1.38"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          stroke="rgb(98.823529%,0%,0%)"
          strokeOpacity="1"
          strokeMiterlimit="10"
          transform="matrix(1.474057,0,0,1.474057,0,0)"
        >
          <path
            fill="none"
            strokeWidth="1.38"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            stroke="rgb(98.823529%,0%,0%)"
            strokeOpacity="1"
            strokeMiterlimit="10"
            d="M 9.0789 23.60885 C 10.40125 20.5693 13.4302 18.4387 16.96 18.4387 C 20.4898 18.4387 23.51875 20.5693 24.8411 23.60885"
          />
        </g>
      </g>
    </svg>
  )
}
